<template>
    <div
        v-b-tooltip.hover.left
        :title="$t('shared.chat.help')"
        class="btn-primary btn clickable help-btn"
        @click="helpClick"
    >
        <BaseIcon class="icon" name="question" />
    </div>
</template>

<script>
import IntercomService from '~/services/IntercomService';

export default {
    name: 'IntercomChat',
    methods: {
        helpClick() {
            IntercomService.show();
        },
    },
};
</script>

<style scoped>
.help-btn {
    font-size: 100%;
    display: flex;
    justify-content: center;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 2px 3px rgba(0, 0, 0, 0.11);
    position: fixed;
    right: 20px;
    bottom: 20px;
    background: linear-gradient(135deg, rgb(63, 81, 181) 0%, rgb(37, 47, 105) 100%);
    border: 0;
    z-index: 10000;
}
.icon {
    font-size: 30px;
    color: white;
}
</style>
